/* eslint-disable no-useless-escape */
// 判断是否为移动端的正则
var mobileDevReg = /android|iPod|ipad|iPhone|mobile/i;
/**
 * copy自@tencent/useragent
 */
export function uaMatch(ua) {
    var _a, _b, _c;
    ua = ua || navigator.userAgent;
    ua = ua.toLowerCase();
    this.browser = {};
    this.os = {};
    this.mobile = false;
    this.spider = /(googlebot|bingbot|yandex|twitterbot|facebookexternalhit|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest\/0\.|pinterestbot|slackbot|vkShare|W3C_Validator|whatsapp|petalbot|applebot|mpcrawler|spider)/i.test(ua);
    this.headless = /headless/i.test(ua);
    if (mobileDevReg.test(ua))
        this.mobile = true;
    var osDetect = {
        android_1: /android[\s\/]([\d\.]+)/i,
        android_2: /android/i,
        android_3: /MIDP-/i,
        ipod_1: /iPod\stouch;\sCPU\siPhone\sos\s([\d_]+)/i,
        ipod_100: /iPod.*os\s?([\d_\.]+)/i,
        iphone: /iPhone;\sCPU\siPhone\sos\s([\d_]+)/i,
        iphone_100: /iPhone.*os\s?([\d_\.]+)/i,
        ipad_1: /ipad;\scpu\sos\s([\d_]+)/i,
        ipad_2: /ipad([\d]+)?/i,
        windows: /windows\snt\s([\d\.]+)/i,
        mac: /Macintosh.*mac\sos\sx\s([\d_\.]+)/i,
        linux: /Linux/i,
    };
    var osMatch;
    var osName;
    var osKeys = Object.keys(osDetect);
    for (var i = 0, len = osKeys.length; i < len; i++) {
        var osKey = osKeys[i];
        osMatch = osDetect[osKey].exec(ua);
        if (!osMatch)
            continue;
        osName = osKey.replace(/_\d+/, '');
        this.os[osName] = true;
        this.os.osName = osName;
        if (osMatch[1])
            this.os.version = osMatch[1].replace(/_/g, '.');
        break;
    }
    // $.os.ios
    if (this.os.iphone || this.os.ipad || this.os.ipod) {
        this.os.ios = true;
    }
    var browserDetect = {
        wechat: /MicroMessenger\/([\d\.]+)/i,
        ipadqq: /IPadQQ\/([\d\.]+)/i,
        mqq: /qq\/([\d\.]+)/i,
        qzone: /QZONEJSSDK\/([\d\.]+)/i,
        mqqbrowser: /mqqbrowser\/([\d\.]+)/i,
        qqbrowser: /[^m]QQBrowser\/([\d\.]+)/i,
        x5: /tbs\/(\d+)/i,
        uc: /UCBrowser\/([\d\.]+)/i,
        edg: /Edg\/([\d\.]+)/i,
        safari_1: /Version\/(([\d\.]+))\sSafari\/[\d\.]+/i,
        safari_2: /Safari\/([\d\.]+)/i,
        chrome_1: /CriOS\/([\d\.]+)/i,
        chrome_2: /Chrome\/([\d\.]+)/i,
        firefox: /Firefox\/([\d\.]+)/i,
        ie_1: /MSIE\s([\d\.]+)/i,
        ie_2: /(trident\/\d\.\d)/i,
        ie_3: /Edge\/(\d+\.\d+)/i,
        weibo: /weibo__([\d\.]+)/i,
        qqnews: /qqnews\/([\d\.]+)/i,
        qqlive_1: /QQLiveBrowser\/([\d\.]+)/i,
        qqlive_2: /QQLiveHDBrowser\/([\d\.]+)/i,
        kuaibao: /qnreading\/([\d\.]+)/i,
        liebao: /LieBaoFast\/([\d\.]+)/i,
        douban: /com\.douban\.frodo\/([\d\.]+)/i,
        miuibrowser: /MiuiBrowser/i,
        baidu: /baiduboxapp/i,
        browser360: /360browser/i,
        oppobrowser: /OppoBrowser/i,
        qqdownloader: /qqdownloader\/([\d\.]+)/i,
    };
    var browserMatch;
    var browserName;
    var bKeys = Object.keys(browserDetect);
    for (var j = 0, len = bKeys.length; j < len; j++) {
        var bkey = bKeys[j];
        browserMatch = browserDetect[bkey].exec(ua);
        if (!browserMatch)
            continue;
        browserName = bkey.replace(/_\d+/, '');
        if (this.browser[browserName])
            return this;
        this.browser[browserName] = {
            version: browserMatch[1],
        };
        // TODO: 下面两行的意思，就是匹配到的浏览器规则，随便选一个？
        this.browser.browserName = browserName;
        this.browser.version = browserMatch[1];
    }
    // There is no safari in android
    if (this.os.android && this.browser.safari) {
        this.browser.safari = null;
    }
    // chrome come first
    if (this.browser.chrome && this.browser.safari) {
        this.browser.safari = null;
    }
    // https://msdn.microsoft.com/library/ms537503.aspx#TriToken
    if (((_c = (_b = (_a = this.browser) === null || _a === void 0 ? void 0 : _a.ie) === null || _b === void 0 ? void 0 : _b.version) === null || _c === void 0 ? void 0 : _c.indexOf('trident')) > -1) {
        if (this.browser.ie.version.indexOf('6.0') > -1) {
            this.browser.ie.version = '10';
        }
        else if (this.browser.ie.version.indexOf('5.0') > -1) {
            this.browser.ie.version = '9';
        }
        else if (this.browser.ie.version.indexOf('4.0') > -1) {
            this.browser.ie.version = '8';
        }
        else {
            this.browser.ie.version = '11';
        }
    }
    return this;
}
/**
 * ua解析工具
 */
var uaTool = uaMatch.call({}, navigator.userAgent);
export default uaTool;
